import React from 'react';

import { styled } from 'shared/components/ihcl/styled';
import { Text } from 'shared/components/ihcl/text';
import { genExternalLinkHandler } from 'shared/helpers/linking';

const DisclaimerWrapper = styled('div', {
  marginTop: '48px',
});

const Disclaimer = () => (
  <DisclaimerWrapper>
    <Text variant="DisplaySmall" color="grayLabel">
      By signing up you agree to Incredible Health&apos;s&nbsp;
      <a
        href="https://www.incrediblehealth.com/terms.html"
        onClick={genExternalLinkHandler(true)}
        rel="noopener noreferrer"
      >
        Terms of Service
      </a>
      &nbsp;and&nbsp;
      <a
        href="https://www.incrediblehealth.com/privacy.html"
        onClick={genExternalLinkHandler(true)}
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
    </Text>
  </DisclaimerWrapper>
);

export default Disclaimer;
